<template>
  <div class="tw-flex tw-mt-2" v-if="data>=0">
    <span v-show="labelDataRight" class="tw-text-[12px] tw-mr-2 tw-min-[25px]">{{ labelDataRight }}</span>
    <div :class="['tw-w-full tw-bg-[#F1F2F6]  tw-rounded-full tw-h-[12px] tw-mb-3', customBg]">
      <div  :class="['tw-h-[12px] tw-bg-[#065559] tw-rounded-full', customColor]" :style="{ width: data + '%' }"></div>
    </div>
    <span class="tw-text-[12px] tw-ml-2 tw-w-[25px]" >{{labelDataLeft?labelDataLeft:formatData(data)}}</span>
  </div>
</template>
<script>
export default {
  name: 'Bar',
  props: ['data', 'customColor','customBg','labelDataLeft', 'labelDataRight'],
  methods: {
    formatData(value) {
      return value.toFixed(2)+'%';
    },
    checkData(){
      return ;
    }
  },
};
</script>